<script>
    // import { getCSSVar } from '$lib/utils'
    import logo from '../../../assets/logo-header.svg'
    import Footer from '../../../views/Footer.svelte'
    export let title = ''
    export let background = 'white'
    export let style = ''
    let objContainer
    const scrollTop = () => {
        objContainer.scrollTo(0, 0)
    }
</script>

<div class="container bg-{background}">
    <div class="header">
        <img draggable="false" class="logo" src={logo} alt="" />
        <span
            ><p>Portal de Proveedores{title ? '    | ' : ''}</p>
            {#if title}
                <p class="title">{title}</p>
            {/if}
        </span>
        <div class="leftSpace"><slot name="leftSpace" /></div>
    </div>
    <div class="content" {style} bind:this={objContainer}>
        <slot {scrollTop} />
    </div>
    <div class="footer">
        <Footer />
    </div>
</div>

<style>
    .container {
        display: grid;
        grid-template-rows: 72px 1fr auto;
        width: 100%;
        min-height: 100%;
        position: absolute;
    }
    .content {
        grid-row: 2;
        overflow: auto;
        width: 100%;
        min-height: calc(100% - 72px);
        height: auto;
        /* display: flex; */
        display: flex;
        flex-direction: column;
        /* align-items: center;
        justify-content: center; */
        position: relative;
    }
    .header {
        height: 72px;
        width: 100%;
        grid-row: 1;
        position: fixed;
        top: 0;
        background: var(--color-brand-primary-01);
        margin: 0;
        padding: 0 0 0 68px;
        display: flex;
        flex-direction: row;
        align-items: center;
        left: 0;
        z-index: var(--lvl-3);
    }
    .header span {
        display: flex;
        flex-direction: row;
        width: auto;
        margin-left: 32px;
        align-items: center;
        justify-content: flex-start;
    }
    .header p {
        color: white;
        margin-left: 5px;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
    }

    .logo {
        user-select: none;
        height: 56px;
        width: auto;
    }

    .header p.title {
        font-weight: 600;
    }

    .leftSpace {
        position: absolute;
        right: 25px;
        background: rgba(0, 0, 0, 0.1);
    }
    .bg-grey {
        background-color: var(--color-grey-050);
    }
    .bg-white {
        background-color: var(--color-white);
    }
    .footer {
        position: relative;
        grid-row: 3;
    }
</style>
